@if (isSpinnerVisible) {
  <div class="progress"
    >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
